/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import clsx from 'clsx';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { RemixIcon } from 'helpers/RemixIcon';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const KeyInformation = (props)=>{
    const isEditing = useIsEditing();
    const styles = parseStyleParams(props.params, []);
    const alignment = props?.params?.alignment || 'Left'; // Default: Left
    const { itemTitle, itemDescription, itemIcon } = props?.fields || {};
    const { base, contentWrapper, itemContainer, iconTitleContainer, iconWrapper, titleText, contentText } = TAILWIND_VARIANTS({
        alignment: alignment
    });
    /*
   * Rendering
   */ return /*#__PURE__*/ _jsx("article", {
        className: clsx(base(), styles),
        "data-component": "authorable/shared/content/keyinformation",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-key-information-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: contentWrapper(),
            children: /*#__PURE__*/ _jsxs("div", {
                className: itemContainer(),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: clsx(iconTitleContainer()),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: clsx(iconWrapper()),
                                children: /*#__PURE__*/ _jsx(RemixIcon, {
                                    name: itemIcon?.fields?.title?.value || 'information-line',
                                    size: "xl",
                                    "aria-hidden": !!itemTitle?.value,
                                    title: !itemTitle?.value ? itemIcon?.displayName || 'Icon' : undefined
                                })
                            }),
                            itemTitle && /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                className: clsx(titleText()),
                                field: itemTitle,
                                tag: "h3",
                                ...getTestProps(`title`)
                            })
                        ]
                    }),
                    itemDescription && /*#__PURE__*/ _jsx(RichTextWrapper, {
                        className: clsx(contentText()),
                        field: itemDescription,
                        ...getTestProps(`content`)
                    })
                ]
            })
        })
    });
};
export const Default = withStandardComponentWrapper(KeyInformation);
const TAILWIND_VARIANTS = tv({
    defaultVariants: {
        alignment: 'Left'
    },
    slots: {
        base: [
            'relative',
            'w-full'
        ],
        contentWrapper: [
            'relative',
            'flex',
            'flex-col',
            'gap-general-spacing-copy-margin-bottom'
        ],
        itemContainer: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-16'
        ],
        iconTitleContainer: [
            'flex',
            'items-center',
            'gap-spacing-spacing-12'
        ],
        iconWrapper: [
            'w-9',
            'h-9',
            'text-color-core-color-3-Coral',
            'flex-shrink-0'
        ],
        titleText: [
            'font-semibold',
            'font-typography-font-family-body',
            'text-typography-font-size-body-xlarge',
            'text-component-card-item-title',
            'leading-typography-line-height-body-xlarge'
        ],
        contentText: [
            'font-typography-font-family-body',
            'font-normal',
            'text-typography-font-size-body-medium',
            'text-component-card-item-body',
            'leading-typography-line-height-body-medium',
            'mb-0'
        ]
    }
});
